import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import "bootstrap/dist/css/bootstrap.min.css";
import Github from "./Pages/GitHub";
import App from "./Pages/App";
import Header from "./Components/Header";

const test1 = (
  <>
    <p>This is a test component</p>
  </>
);

export const ApplicationWrapper = () => (
  <>
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
      integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3"
      crossOrigin="anonymous"
    />
    <Header></Header>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/test1" element={test1} />
        <Route path="/gh" element={<Github />} />
        <Route path="/home" element={<HomePage />} />
      </Routes>
    </Router>
  </>
);

ReactDOM.render(
  <React.StrictMode>
    <ApplicationWrapper />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
